import type { Module } from 'vuex';
import { TranslateLanguageEntity } from '@/types/TranslateLanguageEntity';
import {RootState} from "@/store";

export interface TranslateLanguageEntitiesState {
  translateLanguageEntities: TranslateLanguageEntity[];
}

const translateLanguageEntitiesModule: Module<TranslateLanguageEntitiesState, RootState> = {
  namespaced: true,

  state: (): TranslateLanguageEntitiesState => ({
    translateLanguageEntities: [],
  }),

  getters: {
    getById: (state) => (idTranslateLanguageEntity: number): TranslateLanguageEntity | undefined => {
      return state.translateLanguageEntities.find(translateLanguageEntity => translateLanguageEntity.idTranslateLanguageEntity === idTranslateLanguageEntity);
    },
    getByLanguageEntity: (state) => (idLanguageEntity: number): TranslateLanguageEntity[] => {
      return state.translateLanguageEntities.filter(translateLanguageEntity => translateLanguageEntity.idLanguageEntity === idLanguageEntity);
    },
  },

  mutations: {
    setTranslateLanguageEntities(
      state,
      payload: { translateLanguageEntities: Record<number, any> }
    ) {
      state.translateLanguageEntities = Object
        .values(payload.translateLanguageEntities)
        .map(raw => TranslateLanguageEntity.fromRaw(raw));
    },

    setTranslateLanguageEntityCreate(
      state,
      payload: {
        idTranslateLanguageEntity: number;
        idLanguageEntity: number;
        idLanguage: number;
        one: string;
        many: string;
      }
    ) {
      const raw = {
        idTranslateLanguageEntity: payload.idTranslateLanguageEntity,
        idLanguageEntity: payload.idLanguageEntity,
        idLanguage: payload.idLanguage,
        one: payload.one,
        many: payload.many,
        locked: false,
      };
      state.translateLanguageEntities.push(TranslateLanguageEntity.fromRaw(raw));
    },

    setTranslateLanguageEntityUpdate(
      state,
      payload: {
        idTranslateLanguageEntity: number;
        one?: string;
        many?: string;
      }
    ) {
      const translateLanguageEntity = state.translateLanguageEntities.find(translateLanguageEntity => translateLanguageEntity.idTranslateLanguageEntity === payload.idTranslateLanguageEntity);
      if (!translateLanguageEntity) return;
      if (payload.one !== undefined) translateLanguageEntity.one = payload.one;
      if (payload.many !== undefined) translateLanguageEntity.many = payload.many;
    },

    setTranslateLanguageEntityDelete(
      state,
      payload: { idTranslateLanguageEntity: number }
    ) {
      state.translateLanguageEntities = state.translateLanguageEntities.filter(
        translateLanguageEntity => translateLanguageEntity.idTranslateLanguageEntity !== payload.idTranslateLanguageEntity
      );
    },

    setTranslateLanguageEntityLock(
      state,
      payload: { idTranslateLanguageEntity: number }
    ) {
      const translateLanguageEntity = state.translateLanguageEntities.find(translateLanguageEntity => translateLanguageEntity.idTranslateLanguageEntity === payload.idTranslateLanguageEntity);
      if (translateLanguageEntity) translateLanguageEntity.locked = true;
    },

    setTranslateLanguageEntityUnlock(
      state,
      payload: { idTranslateLanguageEntity: number }
    ) {
      const translateLanguageEntity = state.translateLanguageEntities.find(translateLanguageEntity => translateLanguageEntity.idTranslateLanguageEntity === payload.idTranslateLanguageEntity);
      if (translateLanguageEntity) translateLanguageEntity.locked = false;
    },
  },

  actions: {
    wsSetTranslateLanguageEntities({ commit }, payload) {
      commit('setTranslateLanguageEntities', payload);
    },
    wsTranslateLanguageEntityCreate({ commit }, payload) {
      commit('setTranslateLanguageEntityCreate', payload);
    },
    wsTranslateLanguageEntityUpdate({ commit }, payload) {
      commit('setTranslateLanguageEntityUpdate', payload);
    },
    wsTranslateLanguageEntityDelete({ commit }, payload) {
      commit('setTranslateLanguageEntityDelete', payload);
    },
    wsTranslateLanguageEntityLock({ commit }, payload) {
      commit('setTranslateLanguageEntityLock', payload);
    },
    wsTranslateLanguageEntityUnlock({ commit }, payload) {
      commit('setTranslateLanguageEntityUnlock', payload);
    },
  },
};

export default translateLanguageEntitiesModule;
